/**
 * @file Lightweight reachability probe. navigator.onLine is true on a
 * Windows desktop that is associated to wifi with no route out, so the pick
 * queue must ask the server before treating the tab as online.
 */

export const HEALTH_PROBE_PATH = '/health';
export const HEALTH_PROBE_TIMEOUT_MS = 4000;

function healthUrl() {
  const base = process.env.REACT_APP_API_URL || '/api';
  return `${String(base).replace(/\/$/, '')}${HEALTH_PROBE_PATH}`;
}

/**
 * @param {typeof fetch} [fetchFn]
 * @returns {Promise<boolean>} true if any HTTP response arrived
 */
export async function probeReachability(fetchFn = fetch) {
  if (typeof navigator !== 'undefined' && navigator.onLine === false) {
    return false;
  }

  const controller = new AbortController();
  const timer = setTimeout(() => controller.abort(), HEALTH_PROBE_TIMEOUT_MS);
  try {
    const res = await fetchFn(healthUrl(), {
      method: 'GET',
      credentials: 'include',
      cache: 'no-store',
      signal: controller.signal,
    });
    // Any response means the API is reachable; 5xx is still "online".
    return typeof res?.status === 'number';
  } catch {
    return false;
  } finally {
    clearTimeout(timer);
  }
}
